import React from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {showToast, updateWpConnectionError} from "../../../Common/Appcommon";
import CampaignOperations from "../../Campaigns/CampaignOperations";
import { useForm, Controller } from "react-hook-form";

const Templates = ({
     isOpen,
     toggleModal,
     user,
     refreshChat
}) => {
    const form = useForm();
    const postSendActions = async (data) => {
        if(data['status'] === 'success'){
            toggleModal();
            await refreshChat();
            showToast('send successfully');
        }else{
            if(data['showmsg']  !== undefined && data['showmsg'] === true){
                showToast(data['message'],'top-right','error');
            }else{
                showToast('message failed to send!','top-right','error');
            }

            //update API Error in session to show notification to user.
            if(data['wpApiError'] !== undefined && data['wpApiError'] === true){
                updateWpConnectionError('true');
            }
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={toggleModal}
               className={'le-modal-lg campaign-modal'}>
            <ModalBody>
                <CampaignOperations
                    campaignSaveOperation={postSendActions}
                    automationId={""}
                    campaignId={""}
                    leadInfo={user}
                    isModal={true}
                    isInbox={true}
                    closeModal={toggleModal}
                    useForm={form}
                    controller={Controller}
                />
            </ModalBody>
        </Modal>
    );
};

export default Templates;
